// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var Screenshot$SmartcutsMacros = require("./Screenshot.bs.js");
var PromisedValue$SmartcutsMacros = require("./PromisedValue.bs.js");

var key_encode = Decco.stringToJson;

var key_decode = Decco.stringFromJson;

function generateKey(param) {
  return Uuid.v1();
}

function makeKey(param) {
  return Uuid.v1();
}

function makeKeyFromString(s) {
  return s;
}

function keyAsString(key) {
  return key;
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "resolvedToId",
                Decco.optionToJson(Decco.intToJson, v.resolvedToId)
              ],
              [
                "insertAfterId",
                Decco.intToJson(v.insertAfterId)
              ],
              [
                "insertSeq",
                Decco.intToJson(v.insertSeq)
              ],
              [
                "screenshot",
                PromisedValue$SmartcutsMacros.t_encode(Screenshot$SmartcutsMacros.t_encode, Image$SmartcutsMacros.id_encode, v.screenshot)
              ],
              [
                "timestamp",
                Decco.floatToJson(v.timestamp)
              ],
              [
                "url",
                Decco.stringToJson(v.url)
              ],
              [
                "tabId",
                Decco.intToJson(v.tabId)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var resolvedToId = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "resolvedToId"), null));
  if (resolvedToId.TAG === /* Ok */0) {
    var insertAfterId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "insertAfterId"), null));
    if (insertAfterId.TAG === /* Ok */0) {
      var insertSeq = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "insertSeq"), null));
      if (insertSeq.TAG === /* Ok */0) {
        var screenshot = PromisedValue$SmartcutsMacros.t_decode(Screenshot$SmartcutsMacros.t_decode, Image$SmartcutsMacros.id_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "screenshot"), null));
        if (screenshot.TAG === /* Ok */0) {
          var timestamp = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "timestamp"), null));
          if (timestamp.TAG === /* Ok */0) {
            var url = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
            if (url.TAG === /* Ok */0) {
              var tabId = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tabId"), null));
              if (tabId.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          resolvedToId: resolvedToId._0,
                          insertAfterId: insertAfterId._0,
                          insertSeq: insertSeq._0,
                          screenshot: screenshot._0,
                          timestamp: timestamp._0,
                          url: url._0,
                          tabId: tabId._0
                        }
                      };
              }
              var e = tabId._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".tabId" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = url._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".url" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = timestamp._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".timestamp" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = screenshot._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".screenshot" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = insertSeq._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".insertSeq" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = insertAfterId._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".insertAfterId" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = resolvedToId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".resolvedToId" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function getScreenshotId(param) {
  var promisedScreenshot = param.screenshot;
  if (promisedScreenshot.TAG === /* Resolved */0) {
    return Screenshot$SmartcutsMacros.idGet(promisedScreenshot._0);
  } else {
    return Caml_option.some(promisedScreenshot._0);
  }
}

function minify(info) {
  var promisedScreenshot = info.screenshot;
  var tmp;
  tmp = promisedScreenshot.TAG === /* Resolved */0 ? ({
        TAG: /* Resolved */0,
        _0: Screenshot$SmartcutsMacros.minify(promisedScreenshot._0)
      }) : promisedScreenshot;
  return {
          resolvedToId: info.resolvedToId,
          insertAfterId: info.insertAfterId,
          insertSeq: info.insertSeq,
          screenshot: tmp,
          timestamp: info.timestamp,
          url: info.url,
          tabId: info.tabId
        };
}

exports.key_encode = key_encode;
exports.key_decode = key_decode;
exports.generateKey = generateKey;
exports.makeKey = makeKey;
exports.makeKeyFromString = makeKeyFromString;
exports.keyAsString = keyAsString;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.getScreenshotId = getScreenshotId;
exports.minify = minify;
/* uuid Not a pure module */
